<div id="timeline" #timeline [style.padding-bottom]="addBottomPaddingPxAmount + 'px'">
  <div class="selectable horizontal_flex" style="flex: 1; position: relative" [ngClass]="selected ? 'selected ' : ''">
    <div style="position: relative; z-index: 50" class="horizontal_flex">
      @if (showLabel) {
        <div
          (click)="selectTourEvent.emit(tour)"
          style="width: 46px; font-size: 0.75rem; text-align: center"
          class="black_gradient_background horizontal_flex"
        >
          <div
            [style.background-color]="
              PAUtil.getIndexColorString(PATimeControl.Instance.weekDays.indexOf(tour.technicianDate.day.week_day))
            "
            style="width: 6px"
          ></div>
          @if (tour.technicianDate.isTodaysTechnicianDate) {
            <div style="margin: auto auto auto 2px; font-size: 0.8rem">Heute</div>
          }
          @if (!tour.technicianDate.isTodaysTechnicianDate) {
            <div style="flex: 1; position: relative">
              <div
                class="horizontal_flex"
                style="
                  position: absolute;
                  top: 0;
                  left: 2px;
                  bottom: 0;
                  text-align: center;
                  right: 60%;
                  font-size: 0.8rem;
                "
              >
                <div style="margin: auto auto auto 0">
                  {{ PATimeControl.Instance.weekDayToGermanName(tour.technicianDate.day.week_day, true) }}
                </div>
              </div>
              <div
                class="horizontal_flex"
                style="
                  position: absolute;
                  bottom: 0;
                  top: 0;
                  right: 4px;
                  text-align: center;
                  left: 40%;
                  font-size: 0.55rem;
                  line-height: 0.6rem;
                "
              >
                <div style="margin: auto 0 auto auto; color: lightgray">
                  <i
                    >KW <br />
                    {{
                      PATimeControl.Instance.timestampToCalendarWeek(tour.technicianDate.day.utc_timestamp).number
                    }}</i
                  >
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if (mapContainer) {
        <hawk-travel-technician-menu
          style="display: inline-flex; width: 24px"
          [dayTimestamp]="tour.technicianDate.day.utc_timestamp - 24 * 60 * 60 * 1000"
          [mapBoxAccessToken]="mapBoxLoadingService.accessToken"
          [mapContainer]="mapContainer"
          [tooltip]="'Reisestart festlegen'"
          [anchor]="'left'"
          [technicianDateCollection]="technicianDateCollection"
        ></hawk-travel-technician-menu>
      }
    </div>
    <div
      class="vertical_flex"
      style="flex: 1; background-color: white; position: relative"
      (click)="selectTourEvent.emit(tour)"
      [ngClass]="tour.technicianDate.isPastTechnicianDate ? 'striped_background' : ''"
    >
      @for (timestamp of timelineTimestamps; track timestamp) {
        <div
          class="edit_timeline"
          style="
            position: absolute;
            transform: translate(-50%, 0);
            top: 0;
            display: inline-flex;
            flex-direction: column;
          "
          [style.left]="timestamp.offset_percent"
        >
          <div
            style="margin: auto; width: 1px; background-color: #adadad"
            [style.height]="
              showHours ? (showCompareTour ? 2 : 1) * height + 6 + 'px' : (showCompareTour ? 2 : 1) * height + 'px'
            "
          ></div>
          @if (showHours) {
            <div style="font-size: 0.7rem; color: white">
              {{ timestamp.time_string }}
            </div>
          }
        </div>
      }
      @if (showCompareTour) {
        <div style="position: relative" [style.height]="height + 'px'">
          @if (compareTour) {
            <div class="route_container" style="border-bottom: 1px solid black">
              @for (operation of compareTour.operations; track operation) {
                <div
                  [style.background-color]="
                    Util.rgbaToString(
                      Util.hexToRgba(PADataControl.Instance.getProject(operation.ticket.project.id).color, 0.7)
                    )
                  "
                  [style.left]="
                    compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                      ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.operation
                      .left_percent + '%'
                  "
                  [style.right]="
                    compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                      ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.operation
                      .right_percent + '%'
                  "
                  class="operation"
                  [tooltip]="$any(ctNotEditableTemplate)"
                  contentType="template"
                >
                  @if (
                    showOperationIndexes &&
                    compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                      ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.operation
                      .additional_time_percent
                  ) {
                    <div
                      class="operation_stats_right_container"
                      [style.width]="
                        100 -
                        10000 /
                          (100 +
                            compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                              ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.operation
                              .additional_time_percent) +
                        '%'
                      "
                    >
                      <div style="margin: auto; font-size: 0.6rem; position: relative">
                        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
                          +{{
                            compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                              ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.operation
                              .additional_time_percent
                          }}%
                        </div>
                      </div>
                    </div>
                  }
                </div>
                @if (showOperationIndexes) {
                  <div
                    class="operation_index"
                    [style.left]="
                      compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                        ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.operation
                        .middle_percent + '%'
                    "
                  >
                    <div
                      class="operation_index_content"
                      [style.background-color]="
                        PAUtil.getIndexColorString(
                          PATimeControl.Instance.weekDays.indexOf(compareTour.technicianDate.day.week_day)
                        )
                      "
                    >
                      <div
                        style="
                          margin: auto;
                          line-height: 0.85rem;
                          display: flex;
                          flex-direction: row;
                          white-space: pre-line;
                        "
                      >
                        @if (tour.getTourIndexForOperationWithId(operation.id) + 1) {
                          {{ tour.getTourIndexForOperationWithId(operation.id) + 1 }}
                        }
                        @if (!(tour.getTourIndexForOperationWithId(operation.id) + 1)) {
                          &#x2716;
                        }
                        @if (operation.getStore().letter) {
                          |{{ operation.getStore().letter }}
                        }
                        @if (operation.date_fixed) {
                          |<fa-icon style="font-size: 0.6rem" [icon]="faCalendarCheck"></fa-icon>
                        }
                      </div>
                    </div>
                    @if (operation.date_travel_start && !operation.date_on_site && !operation.date_finished) {
                      <div
                        style="
                          position: absolute;
                          left: 50%;
                          transform: translateX(-50%);
                          bottom: 100%;
                          width: 1px;
                          background: gray;
                          height: 4px;
                        "
                      >
                        <div class="operation_stats_top_container" [tooltip]="'Anfahrt'">
                          <fa-icon
                            style="
                              color: dodgerblue;
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                            "
                            [icon]="faCar"
                          ></fa-icon>
                        </div>
                      </div>
                    }
                    @if (operation.date_on_site && !operation.date_finished) {
                      <div
                        style="
                          position: absolute;
                          left: 50%;
                          transform: translateX(-50%);
                          bottom: 100%;
                          width: 1px;
                          background: gray;
                          height: 4px;
                        "
                      >
                        <div class="operation_stats_top_container" [tooltip]="'In Bearbeitung'">
                          <fa-icon
                            style="
                              color: darkorange;
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                            "
                            [icon]="faWrench"
                          ></fa-icon>
                        </div>
                      </div>
                    }
                    @if (operation.date_finished) {
                      <div
                        style="
                          position: absolute;
                          left: 50%;
                          transform: translateX(-50%);
                          bottom: 100%;
                          width: 1px;
                          background: gray;
                          height: 4px;
                        "
                      >
                        <div class="operation_stats_top_container" [tooltip]="'Erledigt'">
                          <fa-icon
                            style="
                              color: greenyellow;
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                            "
                            [icon]="faCheck"
                          ></fa-icon>
                        </div>
                      </div>
                    }
                  </div>
                }
                <div
                  [style.background-color]="'gray'"
                  [style.left]="
                    compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                      ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.driving
                      .left_percent + '%'
                  "
                  [style.right]="
                    compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                      ?.operation_data[compareTour.operations.indexOf(operation)]?.timeline_positions.driving
                      .right_percent + '%'
                  "
                  [ngClass]="
                    [compareTour.operations.indexOf(operation) == 0 ? 'first_driving' : 'inter_driving'].join(' ')
                  "
                >
                  @if (
                    compareTour.operations.indexOf(operation) == 0 &&
                    (compareTour.technicianDate.technician.location.coordinates.latitude !=
                      compareTour.startLocation.coordinates.latitude ||
                      compareTour.technicianDate.technician.location.coordinates.longitude !=
                        compareTour.startLocation.coordinates.longitude)
                  ) {
                    <div
                      style="
                        background-size: 100%;
                        width: 18px;
                        height: 18px;
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translate(0, -50%);
                      "
                      class="destination_background_container"
                    >
                      <div
                        class="destination_background"
                        [style.background-color]="
                          PAUtil.getIndexColorString(
                            (PATimeControl.Instance.weekDays.indexOf(compareTour.technicianDate.day.week_day) + 6) % 7
                          )
                        "
                      ></div>
                      <div class="destination_background_border"></div>
                    </div>
                  }
                </div>
                <ng-template #ctNotEditableTemplate>
                  <div style="display: inline-flex; flex: 1; flex-direction: column">
                    <div style="width: 100%; text-align: center">
                      {{ operation.ticket.address_company }}
                    </div>
                    <div
                      style="
                        margin: auto;
                        display: inline-flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        font-size: 0.8rem;
                      "
                    >
                      <div
                        style="
                          margin-top: auto;
                          margin-bottom: auto;
                          border: 1px solid black;
                          display: inline-flex;
                          margin-right: 4px;
                        "
                      >
                        <div
                          style="display: inline-flex; flex-direction: row; margin: auto; padding: 4px 8px"
                          class="black_gradient_background"
                        >
                          <fa-icon style="font-size: 0.8rem; margin-right: 4px" [icon]="faCar"></fa-icon>
                          {{
                            compareTour?.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                              ?.operation_data[compareTour?.operations?.indexOf(operation)]?.operation_time_strings
                              ?.travel_start
                          }}
                        </div>
                      </div>
                      <div
                        style="
                          margin-top: auto;
                          margin-bottom: auto;
                          border: 1px solid black;
                          display: inline-flex;
                          margin-right: 4px;
                        "
                      >
                        <div
                          style="display: inline-flex; flex-direction: row; margin: auto; padding: 4px 8px"
                          class="black_gradient_background"
                        >
                          <fa-icon style="font-size: 0.8rem; margin-right: 4px" [icon]="faWrench"></fa-icon>
                          {{
                            compareTour?.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                              ?.operation_data[compareTour?.operations?.indexOf(operation)]?.operation_time_strings
                              ?.on_site
                          }}
                        </div>
                      </div>
                      <div style="margin-top: auto; margin-bottom: auto; border: 1px solid black; display: inline-flex">
                        <div
                          style="display: inline-flex; flex-direction: row; margin: auto; padding: 4px 8px"
                          class="black_gradient_background"
                        >
                          <fa-icon style="font-size: 0.8rem; margin-right: 4px" [icon]="faCheck"></fa-icon>
                          {{
                            compareTour?.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                              ?.operation_data[compareTour?.operations?.indexOf(operation)]?.operation_time_strings
                              ?.finished
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              }
              @if (
                compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.home_driving
              ) {
                <div
                  [style.background-color]="'gray'"
                  [style.left]="
                    compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                      ?.home_driving.timeline_position.left_percent + '%'
                  "
                  [style.right]="
                    compareTour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                      ?.home_driving.timeline_position.right_percent + '%'
                  "
                  class="home_driving"
                  [ngClass]="!compareTour.operations.length ? 'first_driving' : ''"
                >
                  @if (
                    compareTour.technicianDate.technician.location.coordinates.latitude !=
                      compareTour.endLocation.coordinates.latitude ||
                    compareTour.technicianDate.technician.location.coordinates.longitude !=
                      compareTour.endLocation.coordinates.longitude
                  ) {
                    <div
                      style="
                        background-size: 100%;
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        top: 50%;
                        right: 0;
                        transform: translate(0, -50%);
                      "
                      class="destination_background_container"
                    >
                      <div
                        class="destination_background"
                        [style.background-color]="
                          PAUtil.getIndexColorString(
                            PATimeControl.Instance.weekDays.indexOf(compareTour.technicianDate.day.week_day)
                          )
                        "
                      ></div>
                      <div class="destination_background_border"></div>
                    </div>
                  }
                  @if (
                    !compareTour.operations.length &&
                    (compareTour.technicianDate.technician.location.coordinates.latitude !=
                      compareTour.startLocation.coordinates.latitude ||
                      compareTour.technicianDate.technician.location.coordinates.longitude !=
                        compareTour.startLocation.coordinates.longitude)
                  ) {
                    <div
                      style="
                        background-size: 100%;
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translate(0, -50%);
                      "
                      class="destination_background_container"
                    >
                      <div
                        class="destination_background"
                        [style.background-color]="
                          PAUtil.getIndexColorString(
                            (PATimeControl.Instance.weekDays.indexOf(compareTour.technicianDate.day.week_day) + 6) % 7
                          )
                        "
                      ></div>
                      <div class="destination_background_border"></div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      <div style="position: relative" [style.height]="height + 'px'">
        @if (tour) {
          <div class="route_container">
            @for (operation of tour.operations; track operation) {
              <div
                [style.background-color]="
                  Util.rgbaToString(
                    Util.hexToRgba(PADataControl.Instance.getProject(operation.ticket.project.id).color, 0.7)
                  )
                "
                [style.left]="
                  tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.operation_data[
                    tour.operations.indexOf(operation)
                  ]?.timeline_positions.operation.left_percent +
                  (chainOperations || dragAndDropOperations.includes(operation)
                    ? dragAndDropOffsetPercent * operation.dragDropOffsetFactor
                    : 0) +
                  '%'
                "
                [style.right]="
                  tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.operation_data[
                    tour.operations.indexOf(operation)
                  ]?.timeline_positions.operation.right_percent -
                  (chainOperations || dragAndDropOperations.includes(operation)
                    ? dragAndDropOffsetPercent * operation.dragDropOffsetFactor
                    : 0) +
                  '%'
                "
                class="operation"
                [ngClass]="
                  [
                    dragAndDropOperations.includes(operation) ? 'drag_and_drop_operation' : '',
                    operation.hasStarted() ? '' : 'draggable',
                  ].join(' ')
                "
                [tooltip]="editable ? '' : $any(notEditableTemplate)"
                contentType="template"
                (mousedown)="initDragAndDropCalculation($event, operation)"
              >
                <hawk-popup-menu #OperationPopups>
                  <div class="content" style="position: relative; background: #2d2d2d">
                    <fa-icon
                      style="position: absolute; top: 0; right: 4px; color: white"
                      [icon]="faWindowClose"
                      (click)="closeOperationMenu(tour.operations.indexOf(operation))"
                    ></fa-icon>
                    <div
                      style="display: inline-flex; cursor: default; flex: 1; flex-direction: column; padding: 0"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                    >
                      <div style="display: inline-flex; flex-direction: column; padding: 0; font-size: 0.8rem">
                        <div style="flex: 1; text-align: left; font-size: 0.85rem; line-height: 0.8rem">
                          @if (
                            tour.technicianDate.insertionConfigMap &&
                            tour.technicianDate.insertionConfigMap.has(operation.id)
                          ) {
                            <div
                              class="black_gradient_background_no_hover operation_container horizontal_flex"
                              style="width: 100%"
                            >
                              @if (tour.technicianDate.insertionConfigMap.has(operation.id)) {
                                <div
                                  class="black_gradient_background tour_lock"
                                  [ngClass]="operation.date_travel_start ? 'disabled' : ''"
                                  (click)="toggleOperationRemovability(operation)"
                                >
                                  <fa-icon
                                    style="margin: auto"
                                    [icon]="
                                      tour.technicianDate.insertionConfigMap.get(operation.id).removable
                                        ? faLockOpen
                                        : faLock
                                    "
                                  ></fa-icon>
                                </div>
                              }
                              <div
                                class="horizontal_flex"
                                style="border: 1px solid black; background-color: #673ab7; color: white"
                              >
                                <label style="padding: 0 2px; margin: auto">#</label>
                                <select
                                  (change)="
                                    tour.technicianDate.insertionConfigMap.get(operation.id).tour_index =
                                      eventToNumber($event);
                                    updateNewTourEvent.emit()
                                  "
                                  [disabled]="operation.date_travel_start || operation.date_fixed"
                                >
                                  <option
                                    style="color: black"
                                    [selected]="
                                      tour.technicianDate.insertionConfigMap.get(operation.id).tour_index == -1
                                    "
                                    [value]="-1"
                                  >
                                    Opt
                                  </option>
                                  @for (idx of tour.technicianDate.freeTourIndexes; track idx) {
                                    <!-- Das feste color-Inline-Style würde das Browser-Ausgrauen
                                         von disabled-Optionen überschreiben → Farbe konditional -->
                                    <option
                                      [style.color]="
                                        tour.technicianDate.insertionConfigIndexIsDisabled(idx, operation.id)
                                          ? '#9e9e9e'
                                          : 'black'
                                      "
                                      [selected]="
                                        tour.technicianDate.insertionConfigMap.get(operation.id).tour_index == idx
                                      "
                                      [disabled]="tour.technicianDate.insertionConfigIndexIsDisabled(idx, operation.id)"
                                      [value]="idx"
                                    >
                                      {{ idx + 1 }}
                                    </option>
                                  }
                                </select>
                              </div>
                              <div style="margin: auto; flex: 1; padding-left: 2px">
                                <a style="color: #00acee" [href]="operation.hawkLink" target="_blank">{{
                                  (operation.ticket.address_company || "").slice(0, 26)
                                }}</a>
                              </div>
                            </div>
                          }
                          @if (
                            !tour.technicianDate.insertionConfigMap ||
                            !tour.technicianDate.insertionConfigMap.has(operation.id)
                          ) {
                            {{
                              !operation.ticket.address_company || operation.ticket.address_company?.length < 23
                                ? operation.ticket.address_company
                                : operation.ticket.address_company.slice(0, 21) + "..."
                            }}
                          }
                        </div>
                        <div
                          style="
                            text-align: left;
                            font-size: 0.65rem;
                            line-height: 1rem;
                            color: white;
                            padding-left: 2px;
                          "
                        >
                          {{ operation.ticket.priority.name }}
                          @if (!operation.done) {
                            ({{ getNewToursOperationPriorityCountsBeforeOperation(operation) + 1 }}. Auftrag dieser
                            Priorität)
                          }
                        </div>
                      </div>
                      <div>
                        <div style="width: 100%; display: inline-flex; flex-direction: row">
                          <div
                            style="
                              display: inline-flex;
                              flex-direction: column;
                              font-size: 0.8rem;
                              margin: auto 2px auto auto;
                            "
                          >
                            <div
                              style="
                                margin-top: auto;
                                margin-bottom: auto;
                                border: 1px solid black;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="display: inline-flex; flex-direction: row; margin: auto; padding: 2px"
                                class="black_gradient_background_no_hover"
                              >
                                <fa-icon style="font-size: 0.9rem; margin-right: 2px" [icon]="faCar"></fa-icon>
                                <input
                                  type="time"
                                  [disabled]="operation.date_travel_start || operation.date_fixed"
                                  [value]="
                                    tour.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                                      ?.operation_data[tour.operations?.indexOf(operation)]?.operation_time_strings
                                      ?.travel_start
                                  "
                                  (change)="shiftSelectedOperationTimes($event, operation, 'travel_start')"
                                />
                              </div>
                            </div>
                            <div
                              style="
                                margin-top: auto;
                                margin-bottom: auto;
                                border: 1px solid black;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="display: inline-flex; flex-direction: row; margin: auto; padding: 2px"
                                class="black_gradient_background_no_hover"
                              >
                                <fa-icon style="font-size: 0.9rem; margin-right: 2px" [icon]="faWrench"></fa-icon>
                                <input
                                  type="time"
                                  [disabled]="operation.date_travel_start || operation.date_fixed"
                                  [value]="
                                    tour.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                                      ?.operation_data[tour.operations?.indexOf(operation)]?.operation_time_strings
                                      ?.on_site
                                  "
                                  (change)="shiftSelectedOperationTimes($event, operation, 'on_site')"
                                />
                              </div>
                            </div>
                            <div
                              style="
                                margin-top: auto;
                                margin-bottom: auto;
                                border: 1px solid black;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="display: inline-flex; flex-direction: row; margin: auto; padding: 2px"
                                class="black_gradient_background_no_hover"
                              >
                                <fa-icon style="font-size: 0.9rem; margin-right: 0" [icon]="faCheck"></fa-icon>
                                <input
                                  type="time"
                                  [disabled]="operation.date_travel_start || operation.date_fixed"
                                  [value]="
                                    tour.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                                      ?.operation_data[tour.operations?.indexOf(operation)]?.operation_time_strings
                                      ?.finished
                                  "
                                  (change)="shiftSelectedOperationTimes($event, operation, 'finished')"
                                />
                              </div>
                            </div>
                          </div>
                          <div style="font-size: 0.7rem; flex: 1; display: inline-flex; flex-direction: column">
                            @if (!operation.date_finished) {
                              <div
                                style="
                                  display: inline-flex;
                                  flex-direction: row;
                                  flex: 1;
                                  background: #517b4a;
                                  border: 1px solid black;
                                  margin: auto;
                                "
                              >
                                <div
                                  style="
                                    display: inline-flex;
                                    flex-direction: column;
                                    line-height: 15px;
                                    font-size: 11px;
                                    padding: 3px;
                                    margin: auto;
                                  "
                                >
                                  <div><b style="white-space: nowrap">Berechnete Zeit:</b> <br /></div>
                                  <div>
                                    @if (
                                      operation.hasApplyableRampUpTimeRuleForTechnicianAndPriorityIndex(
                                        tour.technicianDate.technician,
                                        getNewToursOperationPriorityCountsBeforeOperation(operation) + 1
                                      )
                                    ) {
                                      Rampup Zeit <br />
                                      <div class="horizontal_flex" style="flex-wrap: nowrap">
                                        <fa-icon [icon]="faArrowRight" style="margin-right: 2px"></fa-icon>
                                        <div style="white-space: nowrap">
                                          {{
                                            Math.round(
                                              operation
                                                .hasApplyableRampUpTimeRuleForTechnicianAndPriorityIndex(
                                                  tour.technicianDate.technician,
                                                  getNewToursOperationPriorityCountsBeforeOperation(operation) + 1
                                                )
                                                .timePredictionFunctionWrapper.predictFunction(
                                                  getNewToursOperationPriorityCountsBeforeOperation(operation) + 1,
                                                  operation.ticket.time_estimation
                                                )
                                            )
                                          }}min (+{{
                                            Math.round(
                                              operation
                                                .hasApplyableRampUpTimeRuleForTechnicianAndPriorityIndex(
                                                  tour.technicianDate.technician,
                                                  getNewToursOperationPriorityCountsBeforeOperation(operation) + 1
                                                )
                                                .timePredictionFunctionWrapper.getAdditionalValue(
                                                  getNewToursOperationPriorityCountsBeforeOperation(operation) + 1
                                                )
                                            )
                                          }}%)
                                        </div>
                                      </div>
                                    } @else {
                                      @if (PAFilterControl.Instance.selectedOperationTimeFilter === "planned") {
                                        <div>
                                          Hinterlegte Zeit <br />
                                          <div class="horizontal_flex wrap">
                                            <fa-icon [icon]="faArrowRight" style="margin-right: 2px"></fa-icon>
                                            {{ operation.ticket.time_estimation }}min
                                          </div>
                                        </div>
                                      }
                                      @if (PAFilterControl.Instance.selectedOperationTimeFilter === "average") {
                                        <div>
                                          Durchschnittszeit <br />
                                          <div class="horizontal_flex wrap">
                                            <fa-icon [icon]="faArrowRight" style="margin-right: 2px"></fa-icon>
                                            @if (
                                              tour.technicianDate.technician.getPriorityBasedAverageOperationTime(
                                                operation.ticket.priority.id
                                              ) >= 0
                                            ) {
                                              {{
                                                tour.technicianDate.technician.getPriorityBasedAverageOperationTime(
                                                  operation.ticket.priority.id
                                                )
                                              }}min
                                            } @else {
                                              @if (
                                                tour.technicianDate.technician.getPriorityBasedAverageOperationTime(
                                                  operation.ticket.priority.id
                                                ) == -1
                                              ) {
                                                keine Daten
                                              } @else {
                                                Daten inkonsistent!
                                              }
                                            }
                                          </div>
                                        </div>
                                      }
                                    }
                                  </div>
                                </div>
                                <button
                                  class="rampup_button"
                                  (click)="
                                    PASettingsControl.Instance.addAdditionalTechnicianPriorityOperationTimeOnDay(
                                      tour.technicianDate.technician,
                                      operation.ticket.project.id,
                                      operation.ticket.priority.id,
                                      20
                                    )
                                  "
                                >
                                  <div class="flex_row">
                                    <div style="margin: auto; font-size: 0.8rem">
                                      Rampup <br />
                                      Zeit
                                    </div>
                                    <fa-icon style="margin: auto auto auto 4px" [icon]="faCog"></fa-icon>
                                  </div>
                                </button>
                              </div>
                            }
                            @if (operation.date_finished) {
                              <div class="horizontal_flex">
                                <div style="margin: auto; white-space: nowrap">
                                  Erledigt in <br />
                                  <div class="horizontal_flex wrap">
                                    <fa-icon [icon]="faArrowRight" style="margin-right: 2px"></fa-icon>
                                    {{ Math.round(operation.calculateOperationTimeMilliseconds() / 60000) }}min
                                  </div>
                                </div>
                                <fa-icon
                                  style="font-size: 1.2rem; color: greenyellow; margin: auto"
                                  [icon]="faCheckCircle"
                                ></fa-icon>
                              </div>
                            }
                            <div style="display: inline-flex; flex-direction: row; margin: 4px auto auto">
                              <button
                                style="margin: auto 0 0 auto"
                                mat-raised-button
                                color="primary"
                                type="button"
                                (click)="closeOperationMenu(tour.operations.indexOf(operation))"
                              >
                                ok
                              </button>
                              @if (!operation.started) {
                                <button
                                  style="margin: auto auto auto 8px"
                                  mat-raised-button
                                  color="warn"
                                  type="button"
                                  (click)="removeOperation(operation, tour.operations.indexOf(operation))"
                                  [disabled]="!!operation.date_travel_start"
                                >
                                  entfernen
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </hawk-popup-menu>
                @if (
                  showOperationIndexes &&
                  tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.operation_data[
                    tour.operations.indexOf(operation)
                  ]?.timeline_positions.operation.additional_time_percent
                ) {
                  <div
                    class="operation_stats_right_container"
                    [style.width]="
                      100 -
                      10000 /
                        (100 +
                          tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                            ?.operation_data[tour.operations.indexOf(operation)]?.timeline_positions.operation
                            .additional_time_percent) +
                      '%'
                    "
                  >
                    <div style="margin: auto; font-size: 0.6rem; position: relative">
                      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
                        +{{
                          tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                            ?.operation_data[tour.operations.indexOf(operation)]?.timeline_positions.operation
                            .additional_time_percent
                        }}%
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if (showOperationIndexes) {
                <div
                  class="operation_index"
                  [style.left]="
                    tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.operation_data[
                      tour.operations.indexOf(operation)
                    ]?.timeline_positions.operation.middle_percent +
                    (chainOperations || dragAndDropOperations.includes(operation)
                      ? dragAndDropOffsetPercent * operation.dragDropOffsetFactor
                      : 0) +
                    '%'
                  "
                >
                  <div
                    class="operation_index_content"
                    [style.background-color]="
                      PAUtil.getIndexColorString(
                        PATimeControl.Instance.weekDays.indexOf(tour.technicianDate.day.week_day)
                      )
                    "
                  >
                    <div
                      style="
                        margin: auto;
                        line-height: 0.85rem;
                        display: flex;
                        flex-direction: row;
                        white-space: pre-line;
                      "
                    >
                      {{ tour.operations.indexOf(operation) + 1 }}
                      @if (operation.getStore()?.letter) {
                        |{{ operation.getStore().letter }}
                      }
                      @if (operation.date_fixed) {
                        |<fa-icon style="font-size: 0.6rem" [icon]="faCalendarCheck"></fa-icon>
                      }
                    </div>
                  </div>
                  @if (operation.date_travel_start && !operation.date_on_site && !operation.date_finished) {
                    <div
                      style="
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 100%;
                        width: 1px;
                        background: gray;
                        height: 4px;
                      "
                    >
                      <div class="operation_stats_top_container" [tooltip]="'Anfahrt'">
                        <fa-icon
                          style="
                            color: dodgerblue;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                          "
                          [icon]="faCar"
                        ></fa-icon>
                      </div>
                    </div>
                  }
                  @if (operation.date_on_site && !operation.date_finished) {
                    <div
                      style="
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 100%;
                        width: 1px;
                        background: gray;
                        height: 4px;
                      "
                    >
                      <div class="operation_stats_top_container" [tooltip]="'In Bearbeitung'">
                        <fa-icon
                          style="
                            color: darkorange;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                          "
                          [icon]="faWrench"
                        ></fa-icon>
                      </div>
                    </div>
                  }
                  @if (operation.date_finished) {
                    <div
                      style="
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 100%;
                        width: 1px;
                        background: gray;
                        height: 4px;
                      "
                    >
                      <div class="operation_stats_top_container" [tooltip]="'Erledigt'">
                        <fa-icon
                          style="
                            color: greenyellow;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                          "
                          [icon]="faCheck"
                        ></fa-icon>
                      </div>
                    </div>
                  }
                </div>
              }
              <div
                [style.background-color]="'gray'"
                [style.left]="
                  tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.operation_data[
                    tour.operations.indexOf(operation)
                  ]?.timeline_positions.driving.left_percent +
                  (chainOperations || dragAndDropOperations.includes(operation)
                    ? dragAndDropOffsetPercent * operation.dragDropOffsetFactor
                    : 0) +
                  '%'
                "
                [style.right]="
                  tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.operation_data[
                    tour.operations.indexOf(operation)
                  ]?.timeline_positions.driving.right_percent -
                  (chainOperations || dragAndDropOperations.includes(operation)
                    ? dragAndDropOffsetPercent * operation.dragDropOffsetFactor
                    : 0) +
                  '%'
                "
                [ngClass]="
                  [
                    tour.operations.indexOf(operation) == 0 ? 'first_driving' : 'inter_driving',
                    operation.hasStarted() ? '' : 'draggable',
                  ].join(' ')
                "
                (mousedown)="initDragAndDropCalculation($event, operation)"
              >
                @if (
                  tour.operations.indexOf(operation) == 0 &&
                  (tour.technicianDate.technician.location.coordinates.latitude !=
                    tour.startLocation.coordinates.latitude ||
                    tour.technicianDate.technician.location.coordinates.longitude !=
                      tour.startLocation.coordinates.longitude)
                ) {
                  <div
                    style="
                      background-size: 100%;
                      width: 18px;
                      height: 18px;
                      position: absolute;
                      top: 50%;
                      left: 0;
                      transform: translate(0, -50%);
                    "
                    class="destination_background_container"
                  >
                    <div
                      class="destination_background"
                      [style.background-color]="
                        PAUtil.getIndexColorString(
                          (PATimeControl.Instance.weekDays.indexOf(tour.technicianDate.day.week_day) + 6) % 7
                        )
                      "
                    ></div>
                    <div class="destination_background_border"></div>
                  </div>
                }
              </div>
              <ng-template #notEditableTemplate>
                <div style="display: inline-flex; flex: 1; flex-direction: column">
                  <div style="width: 100%; text-align: center">
                    {{ operation.ticket.address_company }}
                  </div>
                  <div
                    style="margin: auto; display: inline-flex; flex-direction: row; flex-wrap: wrap; font-size: 0.8rem"
                  >
                    <div
                      style="
                        margin-top: auto;
                        margin-bottom: auto;
                        border: 1px solid black;
                        display: inline-flex;
                        margin-right: 4px;
                      "
                    >
                      <div
                        style="display: inline-flex; flex-direction: row; margin: auto; padding: 4px 8px"
                        class="black_gradient_background"
                      >
                        <fa-icon style="font-size: 0.8rem; margin-right: 4px" [icon]="faCar"></fa-icon>
                        {{
                          tour?.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                            ?.operation_data[tour?.operations?.indexOf(operation)]?.operation_time_strings?.travel_start
                        }}
                      </div>
                    </div>
                    <div
                      style="
                        margin-top: auto;
                        margin-bottom: auto;
                        border: 1px solid black;
                        display: inline-flex;
                        margin-right: 4px;
                      "
                    >
                      <div
                        style="display: inline-flex; flex-direction: row; margin: auto; padding: 4px 8px"
                        class="black_gradient_background"
                      >
                        <fa-icon style="font-size: 0.8rem; margin-right: 4px" [icon]="faWrench"></fa-icon>
                        {{
                          tour?.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                            ?.operation_data[tour?.operations?.indexOf(operation)]?.operation_time_strings?.on_site
                        }}
                      </div>
                    </div>
                    <div style="margin-top: auto; margin-bottom: auto; border: 1px solid black; display: inline-flex">
                      <div
                        style="display: inline-flex; flex-direction: row; margin: auto; padding: 4px 8px"
                        class="black_gradient_background"
                      >
                        <fa-icon style="font-size: 0.8rem; margin-right: 4px" [icon]="faCheck"></fa-icon>
                        {{
                          tour?.route?.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]
                            ?.operation_data[tour?.operations?.indexOf(operation)]?.operation_time_strings?.finished
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            }
            @if (tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.home_driving) {
              <div
                [style.background-color]="'gray'"
                [style.left]="
                  tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.home_driving
                    .timeline_position.left_percent +
                  (tour.operations?.length &&
                  (chainOperations || dragAndDropOperations.includes(tour.operations[tour.operations?.length - 1]))
                    ? dragAndDropOffsetPercent * tour.operations[tour.operations?.length - 1].dragDropOffsetFactor
                    : 0) +
                  '%'
                "
                [style.right]="
                  tour.route.time_specific_data[PAFilterControl.Instance.selectedOperationTimeFilter]?.home_driving
                    .timeline_position.right_percent -
                  (tour.operations?.length &&
                  (chainOperations || dragAndDropOperations.includes(tour.operations[tour.operations?.length - 1]))
                    ? dragAndDropOffsetPercent * tour.operations[tour.operations?.length - 1].dragDropOffsetFactor
                    : 0) +
                  '%'
                "
                class="home_driving"
                [ngClass]="!tour.operations.length ? 'first_driving' : ''"
              >
                @if (
                  tour.technicianDate.technician.location.coordinates.latitude !=
                    tour.endLocation.coordinates.latitude ||
                  tour.technicianDate.technician.location.coordinates.longitude !=
                    tour.endLocation.coordinates.longitude
                ) {
                  <div
                    style="
                      background-size: 100%;
                      width: 20px;
                      height: 20px;
                      position: absolute;
                      top: 50%;
                      right: 0;
                      transform: translate(0, -50%);
                    "
                    class="destination_background_container"
                  >
                    <div
                      class="destination_background"
                      [style.background-color]="
                        PAUtil.getIndexColorString(
                          PATimeControl.Instance.weekDays.indexOf(tour.technicianDate.day.week_day)
                        )
                      "
                    ></div>
                    <div class="destination_background_border"></div>
                  </div>
                }
                @if (
                  !tour.operations.length &&
                  (tour.technicianDate.technician.location.coordinates.latitude !=
                    tour.startLocation.coordinates.latitude ||
                    tour.technicianDate.technician.location.coordinates.longitude !=
                      tour.startLocation.coordinates.longitude)
                ) {
                  <div
                    style="
                      background-size: 100%;
                      width: 20px;
                      height: 20px;
                      position: absolute;
                      top: 50%;
                      left: 0;
                      transform: translate(0, -50%);
                    "
                    class="destination_background_container"
                  >
                    <div
                      class="destination_background"
                      [style.background-color]="
                        PAUtil.getIndexColorString(
                          (PATimeControl.Instance.weekDays.indexOf(tour.technicianDate.day.week_day) + 6) % 7
                        )
                      "
                    ></div>
                    <div class="destination_background_border"></div>
                  </div>
                }
              </div>
            }
            @if (tour.lunchBreak && tour.lunchBreak.after_operation_idx < tour.operations?.length) {
              <div
                class="lunch_break"
                (click)="openLunchBreakMenu()"
                [style.left]="
                  tour.getLunchBreakTimelinePosition({ offset_percent: lunchBreakOffsetPercent() }).left_percent + '%'
                "
                [style.right]="
                  tour.getLunchBreakTimelinePosition({ offset_percent: lunchBreakOffsetPercent() }).right_percent + '%'
                "
              >
                <div style="margin: auto">
                  <fa-icon [icon]="faUtensils"></fa-icon>
                </div>
                <hawk-popup-menu #LunchBreakPopup>
                  <div class="horizontal_flex content">
                    <div style="display: inline-flex; flex-direction: row; width: fit-content" class="config_button">
                      <div
                        style="color: white; padding: 3px 4px; white-space: nowrap; display: inline-flex"
                        class="black_gradient_background"
                        (click)="toggleLunchBreakCalculation(tour.technicianDate)"
                      >
                        <div style="margin: auto">
                          Pause:
                          {{ tour.technicianDate.automaticLunchBreakCalculation ? "Automatisch" : "Nach Auftrag" }}
                        </div>
                      </div>
                      @if (!tour.technicianDate.automaticLunchBreakCalculation) {
                        <input
                          style="margin: auto; width: 40px"
                          type="number"
                          [(ngModel)]="tour.technicianDate.lunchBreakAfterOperationNumber"
                          min="1"
                          [max]="tour.operations.length - 1"
                          (ngModelChange)="tour.technicianDate.updateNewTourConfig()"
                        />
                      }
                    </div>
                    <fa-icon
                      style="margin: auto 2px"
                      (click)="lunchBreakPopup.close()"
                      [icon]="faWindowClose"
                    ></fa-icon>
                  </div>
                </hawk-popup-menu>
              </div>
            }
            @for (outside_opening_zone of outsideOpeningZones; track outside_opening_zone) {
              <div
                class="outside_opening_zone"
                [tooltip]="outside_opening_zone.info"
                (mousedown)="initDragAndDropCalculation($event, outside_opening_zone.operation)"
                [style.left]="outside_opening_zone.left_percent + '%'"
                [style.right]="outside_opening_zone.right_percent + '%'"
              ></div>
            }
          </div>
        }

        @if (showTimeMarker) {
          @for (opening_timeline_position of tour.route.marker_collection; track opening_timeline_position) {
            <div class="time_marker_root" [style.left]="opening_timeline_position.percent + '%'">
              <div class="time_marker_content bg-accent">
                @for (marker of opening_timeline_position.markers; track marker) {
                  <div style="margin: auto">
                    {{ marker.type }}
                  </div>
                  <div style="margin: auto">
                    <sub>{{ marker.index }}</sub>
                  </div>
                  @if (
                    opening_timeline_position.markers?.indexOf(marker) != opening_timeline_position.markers?.length - 1
                  ) {
                    <div style="margin: auto">,</div>
                  }
                }
              </div>
            </div>
          }
        }
        @if (minuteMarkerPercentage) {
          <div class="bg-primary time_marker_root" style="width: 2px" [style.left]="minuteMarkerPercentage + '%'">
            <div class="bg-primary time_marker_content" style="color: white !important">
              <div style="margin: auto; padding: 2px">Jetzt</div>
            </div>
          </div>
        }
        @if (getWorkStartMarkerPercentage() !== null) {
          <div class="work_start_marker_root" [style.left]="getWorkStartMarkerPercentage() + '%'">
            @if (showWorkStartMarkerHeader) {
              <div class="work_start_marker_header">
                <div style="margin: auto; padding: 2px; white-space: nowrap">
                  Start
                  {{
                    PASettingsControl.Instance.getWorkStartTimeStringForTechnician(tour.technicianDate.technician.id)
                  }}
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if (showStatistics) {
      <div class="tour_statistic">
        <div class="horizontal_flex">
          <div class="auto_travel_wrapper">
            <div class="horizontal_flex" style="position: relative">
              @if (mapContainer) {
                <hawk-travel-technician-menu
                  style="display: inline-flex; width: 24px"
                  [dayTimestamp]="tour.technicianDate.day.utc_timestamp"
                  [mapBoxAccessToken]="mapBoxLoadingService.accessToken"
                  [mapContainer]="mapContainer"
                  [technicianDateCollection]="technicianDateCollection"
                ></hawk-travel-technician-menu>
              }
              <div
                class="footer"
                [ngClass]="
                  technicianDateCollection?.autoOptimizeTravelDestinationsForDayTimestamps.includes(
                    tour.technicianDate.day.utc_timestamp
                  )
                    ? 'full_opacity'
                    : ''
                "
              >
                auto
              </div>
            </div>
            <div class="expand_container horizontal_flex">
              <div
                class="black_gradient_background horizontal_flex"
                [ngClass]="
                  technicianDateCollection?.autoOptimizeTravelDestinationsForDayTimestamps.includes(
                    tour.technicianDate.day.utc_timestamp
                  )
                    ? 'blue_font blue_border'
                    : ''
                "
                style="height: 100%; width: 48px; border: 1px solid gray; color: gray"
                (click)="toggleAutomaticTravelDestinationOptimization()"
              >
                <div style="margin: auto; font-size: 0.9rem; font-weight: bold">auto</div>
              </div>
              <div
                class="black_gradient_background horizontal_flex"
                style="width: 24px; border: 1px solid black"
                (click)="
                  PASettingsControl.Instance.showSettings = true;
                  PASettingsControl.Instance.activeSettingsTab = 'Planung'
                "
              >
                <fa-icon style="margin: auto" [icon]="faCog"></fa-icon>
              </div>
            </div>
          </div>
          <div
            style="color: orange"
            class="horizontal_flex tour_button_container"
            [ngClass]="
              tour.technicianDate.changedTourContainer.unfittingOperations.length +
                tour.technicianDate.changedTourContainer.deletingOperations.length >
              0
                ? 'black_gradient_background'
                : 'black_gradient_background_no_hover disabled'
            "
            (click)="openWarningsMenu()"
          >
            <fa-icon
              style="margin: auto"
              [style.margin-left]="
                tour.technicianDate.changedTourContainer.unfittingOperations.length +
                  tour.technicianDate.changedTourContainer.deletingOperations.length >
                0
                  ? '2px'
                  : 'auto'
              "
              [icon]="faExclamationTriangle"
            ></fa-icon>
            <div style="position: absolute; bottom: 0; right: 0; font-size: 0.6rem; line-height: 0.6rem">
              {{
                tour.technicianDate.changedTourContainer.unfittingOperations.length +
                  tour.technicianDate.changedTourContainer.deletingOperations.length || ""
              }}
            </div>
            <hawk-popup-menu #WarningsPopup>
              <div class="content">
                <div
                  style="position: absolute; top: 0; right: 0; transform: translateY(-50%)"
                  (click)="closeWarningsMenu()"
                >
                  <fa-icon [icon]="faWindowClose"></fa-icon>
                </div>
                <div style="display: inline-flex; flex-direction: column; width: 250px">
                  @if (tour.technicianDate.changedTourContainer.unfittingOperations.length) {
                    <div style="display: inline-flex; flex-direction: row; flex-wrap: wrap">
                      <div class="operation_warning_header" style="background-color: #bd7301">
                        <div style="margin: auto; font-size: 0.7rem; line-height: 0.7rem">
                          Nicht eingefügt: {{ tour.technicianDate.changedTourContainer.unfittingOperations.length }}
                        </div>
                      </div>
                      <div
                        class="horizontal_flex wrap"
                        style="padding: 2px 0 2px 2px; background-color: #bd7301; border: 1px solid black; width: 100%"
                      >
                        @for (
                          operation of tour.technicianDate.changedTourContainer.unfittingOperations;
                          track operation
                        ) {
                          <div
                            class="black_gradient_background_no_hover operation_container horizontal_flex"
                            [ngClass]="PAStore.selectedStoreInMap == operation.getStore() ? 'selected_store' : ''"
                          >
                            <div
                              style="margin: auto; width: 100px; text-align: center; cursor: pointer; padding: 2px 4px"
                              [tooltip]="operation.ticket.address_company"
                              (click)="PAStoreControl.Instance.selectStore(operation.getStore())"
                            >
                              {{
                                operation.ticket.address_company.length <= 16
                                  ? operation.ticket.address_company
                                  : operation.ticket.address_company.slice(0, 16) + "..."
                              }}
                            </div>
                            @if (tour.technicianDate.insertionConfigMap.has(operation.id)) {
                              <div
                                class="black_gradient_background"
                                style="border: 1px solid white; display: inline-flex; padding: 2px"
                                (click)="
                                  tour.technicianDate.insertionConfigMap.get(operation.id).removable =
                                    !tour.technicianDate.insertionConfigMap.get(operation.id).removable;
                                  tour.technicianDate.updateNewTourConfig()
                                "
                                tooltip="Fest in Tour setzen"
                              >
                                <fa-icon
                                  style="margin: auto"
                                  [icon]="
                                    tour.technicianDate.insertionConfigMap.get(operation.id).removable
                                      ? faLockOpen
                                      : faLock
                                  "
                                ></fa-icon>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (tour.technicianDate.newTourConfig?.delete_operations?.length) {
                    <div style="display: inline-flex; flex-direction: row; flex-wrap: wrap">
                      <div class="operation_warning_header" style="background-color: red">
                        <div style="margin: auto; font-size: 0.7rem; line-height: 0.7rem">
                          Entfernt: {{ tour.technicianDate.newTourConfig.delete_operations.length }}
                        </div>
                      </div>
                      <div
                        class="horizontal_flex wrap"
                        style="padding: 2px 0 2px 2px; width: 100%; background-color: red; border: 1px solid black"
                      >
                        @for (operation of tour.technicianDate.newTourConfig.delete_operations; track operation) {
                          <div
                            [tooltip]="'wieder hinzufügen: ' + operation.ticket.address_company"
                            class="black_gradient_background operation_container horizontal_flex"
                            (click)="tour.technicianDate.restoreOperationToNewTour(operation)"
                            [ngClass]="PAStore.selectedStoreInMap == operation.getStore() ? 'selected_store' : ''"
                          >
                            <div
                              style="margin: auto; width: 100px; text-align: center; cursor: pointer; padding: 2px 4px"
                              (click)="PAStoreControl.Instance.selectStore(operation.getStore())"
                            >
                              {{
                                operation.ticket.address_company.length <= 16
                                  ? operation.ticket.address_company
                                  : operation.ticket.address_company.slice(0, 16) + "..."
                              }}
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </hawk-popup-menu>
          </div>
          <div
            style="color: #337ab7"
            class="tour_button_container horizontal_flex"
            (click)="toggleShowCompareTour()"
            [ngClass]="compareTour ? 'black_gradient_background' : 'black_gradient_background_no_hover disabled'"
            [tooltip]="compareTour ? 'Vorherige Tour anzeigen (Diese Tour wurde geändert)' : null"
          >
            <fa-icon style="margin: auto" [icon]="faCodeBranch"></fa-icon>
          </div>
          <div
            style="color: #9ecbff"
            class="horizontal_flex tour_button_container"
            (click)="openTourDebug()"
            [ngClass]="hasTourDebugRecording ? 'black_gradient_background' : 'black_gradient_background_no_hover disabled'"
            [tooltip]="
              hasTourDebugRecording
                ? 'Debug-Infos zur letzten Tourenberechnung dieses Tages'
                : 'Noch keine Tourenberechnung für diesen Tag aufgezeichnet'
            "
          >
            <fa-icon style="margin: auto" [icon]="faBug"></fa-icon>
          </div>
          <div
            style="color: white"
            class="horizontal_flex tour_button_container"
            (click)="deleteTour()"
            [ngClass]="
              !tour.technicianDate.isPastTechnicianDate &&
              tour.operations.concat(tour.technicianDate.changedTourContainer.unfittingOperations).length
                ? 'black_gradient_background'
                : 'black_gradient_background_no_hover disabled'
            "
            [tooltip]="'Tour löschen: Entfernt alle nicht angefangenen Aufträge aus dieser Tour'"
          >
            <fa-icon style="margin: auto" [icon]="faTrash"></fa-icon>
          </div>
        </div>
        <div style="min-width: 80px" class="horizontal_flex">
          <div style="margin: auto">
            <i>{{ tour.route.driving_kms }}<sub>km</sub></i>
          </div>
          <div style="margin: auto" [style.color]="tour.getTimeColor(timeFilter)">
            <i>{{ tour.route.time_specific_data[timeFilter].total_time }}<sub>min</sub></i>
          </div>
        </div>
      </div>
    }
    @if (showWarnings && warning) {
      <div class="horizontal_flex warning" (click)="$event.stopPropagation()">
        <div style="flex: 1; margin: auto 0; text-align: center">
          {{ warning.info }}
        </div>
        <fa-icon
          style="margin: auto 2px auto auto; color: white; cursor: pointer"
          [icon]="faWindowClose"
          (click)="showWarnings = false"
        ></fa-icon>
      </div>
    }
    @if (tour.technicianDate.latestNewOperationUpdateTimestamp) {
      <div
        style="
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 200;
          background-color: rgba(0, 0, 0, 0.849);
          display: inline-flex;
          overflow-x: auto;
        "
      >
        <div style="color: white; width: 100%; height: fit-content; margin: auto; text-align: center">
          <hawk-throbber [direction]="'horizontal'" [description]="'Berechne optimierte Route...'"></hawk-throbber>
        </div>
      </div>
    }
  </div>
</div>
